module.exports = __webpack_public_path__ + "static/acton_after-70910f9239cca05a4394378fdbf8a310.png";